import React, { Component } from 'react';
import General from '../../../Utils/General';
import debounce from '../../../Utils/Reactive';
import ChatInput from '../ChatInput';
import Footer from '../Footer';
import Axios from 'axios';
import {wrapperEndPoint} from '../../../Utils/Api'
import MessageFeather from '../MessageFeather';
import WelcomeScreen from '../WelcomeScreen/index';
import RechargeOverlay from '../../FeatureComponents/RechargeOverlay';
import OverlayMessage from '../../FeatureComponents/OverlayMessage';
import OverlayFeedback from '../../FeatureComponents/OverlayFeedback';
import OverlayInvalidMessage from '../OverlayInvalidMessage';
import OverlayImageModal from '../OverlayImageModal';
import OverlayIFSCInput from '../OverlayIFSCInput';
import GeneralOverlay from '../GeneralOverlay';
import STPRibbon from '../STPRibbon/STPRibbon';

const SCROLL_CONST = {
    scroll_debounce_time :1200,
    scroll_top : 5
};
var resizeTimeout;

interface IProps { 
    boxRef,
    isChatBodyVisible,
    chatMessages,
    chatInput,
    chatInputDisplayValue,
    handleInput,
    handleKeyUp,
    handleKeyDown,
    handleSubmit,
    toggleLoginScreen,
    quickLinks,
    isSpeech,
    data,
    handleFocus
    predSearchToggle,
    predSearchResponse,
    togglePredSearch,
    assignPredSearchQues
    showWelcomeScreen,
    theme,
    logoImagePath,
    BbpsFlag,
    NoConfirmButton,
    isInputDisabled,
    isPushBotVisible,
    logoutUser,
    transactionResponseAarry,
    website,
    storeChecklist,
    numbersOnly,
    handleFeedBackStar,
    handleQuickLinkSubmit,
    isFeedbackEnable,
    mobankApp
    mycardApp,
    addServerResponse,
    handleJustUIPrintCall,
    CNCLinksOnClick,
    netbanking,
    bwayparamSSO,
    uniqueidSSO,
    isLoggedIn,
    setWorkflowName,
    checkBoxJsonData,
    checkBoxFlag,
    termsCheckBox,
    termsCheckBoxFlag,
    termsText,
    termsLink,
    hideWelcomeScreen,
    showRewardCalender,
    // handleModalToggle
    removeFeedbackOption
}

interface IState {
    isWelcomeScreenVisible : boolean,
    isOverlayRechargeVisible: boolean, 
    overlayData
    isOverlayMessageVisible: boolean;
    overlayMessage: string; //over
    isImageModalVisible: boolean;
    imagePath: string;
    userSelectedBankName: string;
    userSelectedIFSCCode: string;
    isOverlayInputVisible: boolean;
    userSelectedId: number;
    userSelectedAddress;
    isOverlayFeedbackVisible: boolean;
    selectedRating;
    isOverlayVisible:boolean;
    isSTPRibbionVisible:boolean;
    isNewYear: boolean;
    isAnimationNewYearWish: boolean;
    isAnimationNewYearMsg: boolean;
    isAnimationNewYearHeader: boolean;
}

var actualResizeHandler = () => {
    this.setBotBodyHeight();
  }

function resizeThrottler() {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {
        resizeTimeout = null;
        actualResizeHandler();
     
       // The actualResizeHandler will execute at a rate of 15fps
       }, 66);
    }
  }
class ChatBody extends Component<IProps, IState> {

    constructor(props){
        super(props);
        this.state = {
            isNewYear: false,
            isAnimationNewYearWish: false,
            isAnimationNewYearMsg: false,
            isAnimationNewYearHeader: false,
            isWelcomeScreenVisible : true,
            isOverlayRechargeVisible: false, 
            overlayData: [],
            isOverlayMessageVisible: false,
            overlayMessage: "", //over
            isImageModalVisible: false,
            imagePath: "",
            userSelectedBankName: "",
            userSelectedIFSCCode: "", //ABCD
            userSelectedAddress: "",
            isOverlayInputVisible: false,
            userSelectedId: 0,
            isOverlayFeedbackVisible: false,
            selectedRating: "",
            isOverlayVisible:false,
            isSTPRibbionVisible:false
        }
       
    }
  //offerschatbot
  toggleGeneralOverlay(overlayMessage) {
    this.setState({
      isOverlayVisible: !this.state.isOverlayVisible,
      overlayMessage: overlayMessage,
    });
  }
    //SNP Plus Invalid message
    toggleOverlayMessage(overlayMessage) {
        this.setState({
          isOverlayMessageVisible: !this.state.isOverlayMessageVisible,
          overlayMessage: overlayMessage,
        });
      }
      showOverlayIFSCInput(bankName, selectedId) {
        this.setState({
          isOverlayInputVisible: !this.state.isOverlayInputVisible,
          userSelectedBankName: bankName,
          userSelectedId: selectedId,
        });
      }
      sendIFSCCode= (code, address) =>{
        this.setState({
          userSelectedIFSCCode: code,
          isOverlayInputVisible: !this.state.isOverlayInputVisible,
          userSelectedAddress: address == "NA" ? "" : address,
        });
      }
    toggleOverlayRecharge(overlayData){
        this.setState({
            isOverlayRechargeVisible: !this.state.isOverlayRechargeVisible,
             overlayData: overlayData
        
        })
    }

     //feedback*
     toggleOverlayFeedback(selectedRating){
      //  console.log("selec  "+selectedRating)
      this.setState({
          isOverlayFeedbackVisible: !this.state.isOverlayFeedbackVisible,
          selectedRating: selectedRating
      },()=>{
        this.props.handleFeedBackStar(selectedRating)
      })
     }

    toggleImageModal = (imagesrc)=> {
        if(imagesrc.includes("#ImagePath#")){
          this.setState({
            isImageModalVisible: !this.state.isImageModalVisible,
            imagePath: imagesrc,
          });
        }   
      }
  setBotBodyHeight(){
    var mobile , width, height , offset;
    if ((window.innerWidth < 992 || window.screen.width < 992)) {
        // mobile = true;
        // width = General.toVhVw("100vw");
        height = General.toVhVw("100vh") - 50 - 50 - 34 - 10;//3 is some sort of offset
        // offset = 0;
    } else {
        // mobile = false;
        // width = 400;
        height = 490;
        // offset = 10; 
    }
    if(this.props.isInputDisabled) {
      height=height+50;
    }
    // if(this.props.chatMessages.length == 1){
    //  height = height + 33;
    //  console.log("height")
    //  console.log(this.props.chatMessages.length)
    // }

    //change height of chatbody if File upload block is exists
    // height=this.props.isFileUploadBlockVisible?height- 50:height;
    
   // this.props.boxRef.current.style.height = (height+"px");

   //console.log(this.props.boxRef.current)
   
   if(this.props.boxRef.current){
     this.props.boxRef.current.style.height = height+"px";
   }

  }

    showHideWelcomeMessage(ev) {
    /* // the logic below doesn't work
        if(scrollTop >= 30){
            return;
        }else if( scrollTop < 30 && scrollTop > 10 ){
            this.setState({ isWelcomeScreenVisible: true })
        }else if (scrollTop > 10) {
            this.setState({ isWelcomeScreenVisible: false })
        }
    */
      
        if (ev.target.scrollTop > SCROLL_CONST.scroll_top) {
            this.setState({ isWelcomeScreenVisible: false })
        }else {
            this.setState({ isWelcomeScreenVisible: true })
        }
    }
 
    handleBodyScroll(ev){
       //debounce(this.showHideWelcomeMessage.call(this,ev),SCROLL_CONST.scroll_debounce_time);
    }

    componentDidMount() {
        //window.addEventListener("resize", resizeThrottler, false);
        this.setBotBodyHeight();
        window.addEventListener("resize", this.setBotBodyHeight.bind(this), false);
      
          const currentDate = new Date();
          var currentHour = currentDate.getHours();
          var currentMinutes = currentDate.getMinutes();

          const today = new Date();
          const yyyy = today.getFullYear();
          let mm = today.getMonth() + 1; // Months start at 0!
          let dd = today.getDate();
          var d= 0;
          var c = Number('0' + d);
          var formatDD, formatMM;
          console.log(c)
          if (dd < 10) 
          {
           formatDD = '0' + dd
          }else{
            formatDD = dd
          }
          if (mm < 10)
          { 
            formatMM = '0' + mm;
          }else{
            formatMM = mm
          }

       const formattedToday = formatDD + '/' + formatMM + '/' + yyyy;

        
        // var current_time = currentDate.getHours()+":"+currentDate.getMinutes()+":"+ currentDate.getSeconds();
          // console.log(current_time)
          // if ((currentDate >= startDate && currentDate <= endDate ) ) {
            // console.log(currentHour,currentDate)
              if(formattedToday== '27/12/2022' && (currentHour >= 14 &&  currentMinutes<= 25 && currentMinutes >= 10) ){
                (document.querySelector('.sf-header') as HTMLInputElement).style.background = "linear-gradient(14deg, #2E0604, #971E15)"
                  this.setState({isNewYear : true})
                  setTimeout(()=>{this.setState({isAnimationNewYearHeader: true})})
                  setTimeout(()=> {this.setState({isAnimationNewYearWish: true})}, 2000); 
                  setTimeout(()=>{this.setState({isAnimationNewYearMsg: true})},4000)
          }else{
            this.setState({isNewYear : false})
          }
      // }
        if(this.props.chatMessages.length > 1){
            this.setState({ isWelcomeScreenVisible: false });
        }       
    }


  componentWillUnmount() {
    clearTimeout(resizeTimeout) 
  }


    render() {
        return (

            <div id="sf-chat-main-container" className="main-container">
            
            {this.state.isOverlayRechargeVisible ?  
             <RechargeOverlay
                 overlayRechargeToggle={this.toggleOverlayRecharge.bind(this)}
                  data={this.state.overlayData}
                  handleSubmit={this.props.handleSubmit}
             />
            :null }


            {this.state.isOverlayFeedbackVisible ?  
             <OverlayFeedback
                  toggleOverlayFeedback={this.toggleOverlayFeedback.bind(this)}
                  // selectedRating={"3"}
                  closeFlag={false}
                  website={this.props.website}
                  selectedRating={this.state.selectedRating}
                  isLoginUser={this.props.logoutUser}
                  // handleModalToggle={this.props.handleModalToggle}
             />
            :null }

{this.state.isOverlayVisible ? (
          <GeneralOverlay
          toggleGeneralOverlay={this.toggleGeneralOverlay.bind(this)}
            message={this.state.overlayMessage}
          />
        ) : null}
            {this.state.isOverlayMessageVisible ? (
          <OverlayInvalidMessage
            overlayMessageToggle={this.toggleOverlayMessage.bind(this)}
            message={this.state.overlayMessage}
          />
        ) : null}
        {this.state.isOverlayInputVisible ? (
          <OverlayIFSCInput
            selectedIFSCCode={this.sendIFSCCode}
            overlayIFSCInputToggle={this.showOverlayIFSCInput.bind(this)}
            userSelectedBankName={this.state.userSelectedBankName}
            toggleOverlayMessage={this.toggleOverlayMessage.bind(this)}
          />
        ) : null}
       {this.state.isImageModalVisible ? (
          <OverlayImageModal
            overlayImageToggle={this.toggleImageModal}
            imagePath={this.state.imagePath}
          />
        ) : null}
                <div className="sf-chatbody" id="sf-chatbody"
                    onScroll={this.handleBodyScroll.bind(this)}
                    onClick={()=>this.props.togglePredSearch()}
                    ref={this.props.boxRef}
                    style={{ display: this.props.isChatBodyVisible ? "" : "none" }}>
                    {(!window.location.href.includes('pb/') && this.state.isWelcomeScreenVisible) ?
                    // {this.state.isWelcomeScreenVisible ?
                        <WelcomeScreen
                            theme={this.props.theme}
                            animateWish={this.state.isAnimationNewYearWish}
                            animateHeader={this.state.isAnimationNewYearHeader}
                            animateMsg={this.state.isAnimationNewYearMsg}
                            newYear={this.state.isNewYear}
                            data={this.props.data}
                            showWelcomeScreen={this.props.showWelcomeScreen}
                            handleSubmit={this.props.handleSubmit}
                            quickLinks={this.props.quickLinks}
                            handleQuickLinkSubmit={this.props.handleQuickLinkSubmit}
                            mobankApp={this.props.mobankApp}
                            mycardApp={this.props.mycardApp}
                            addServerResponse={this.props.addServerResponse}
                            hideWelcomeScreen={this.props.hideWelcomeScreen}
                            handleJustUIPrintCall={this.props.handleJustUIPrintCall}
                        /> : null
                    }
                    <MessageFeather 
                        isWelcomeScreenVisible={this.state.isWelcomeScreenVisible}
                        quickLinks={this.props.quickLinks}
                        chatMessages={this.props.chatMessages}
                        handleSubmit={this.props.handleSubmit}
                        data={this.props.data}
                        toggleLoginScreen = {this.props.toggleLoginScreen}
                        overlayMessageToggle={this.toggleOverlayMessage.bind(this)}
                        overlayImageModalToggle={this.toggleImageModal}
                        logoImagePath={this.props.logoImagePath}
                        BbpsFlag={this.props.BbpsFlag}
                        NoConfirmButton={this.props.NoConfirmButton}
                        overlayRechargeToggle={this.toggleOverlayRecharge.bind(this)}
                        isPushBotVisible={this.props.isPushBotVisible}
                        logoutUser={this.props.logoutUser}
                        transactionResponseAarry={this.props.transactionResponseAarry}
                        storeChecklist={this.props.storeChecklist.bind(this)}
                        userSelectedIFSCCode={this.state.userSelectedIFSCCode}
                        userSelectedBankName={this.state.userSelectedBankName}
                        userSelectedId={this.state.userSelectedId}
                        userSelectedAddress={this.state.userSelectedAddress}
                        overlayIFSCInputToggle={this.showOverlayIFSCInput.bind(this)}
                        handleQuickLinkSubmit={this.props.handleQuickLinkSubmit}
                        toggleGeneralOverlay={this.toggleGeneralOverlay.bind(this)}
                        CNCLinksOnClick={this.props.CNCLinksOnClick}
                        setWorkflowName={this.props.setWorkflowName}
                        checkBoxJsonData={this.props.checkBoxJsonData}
                        checkBoxFlag={this.props.checkBoxFlag}
                        termsCheckBox={this.props.termsCheckBox}
                        termsCheckBoxFlag={this.props.termsCheckBoxFlag}
                        termsText={this.props.termsText}
                        termsLink={this.props.termsLink}
                        addServerResponse={this.props.addServerResponse}
                        showRewardCalender={this.props.showRewardCalender}
                        removeFeedbackOption={this.props.removeFeedbackOption}
                    />
                </div>

                {(!this.props.showWelcomeScreen && !window.location.href.includes('pb/') && this.props.isChatBodyVisible)?
                
                <STPRibbon 
                  addServerResponse={this.props.addServerResponse}
                  chatMessages={this.props.chatMessages}
                  handleJustUIPrintCall={this.props.handleJustUIPrintCall}
                  isInputDisabled={this.props.isInputDisabled}
         />
                :  null} 

                {(window.location.href.includes('pb/RBLCares') && this.props.isChatBodyVisible)?
                                
                                <STPRibbon 
                                  addServerResponse={this.props.addServerResponse}
                                  chatMessages={this.props.chatMessages}
                                  handleJustUIPrintCall={this.props.handleJustUIPrintCall}
                                  isInputDisabled={this.props.isInputDisabled}
                        />
                                :  null} 
             
                  <ChatInput
                      chatInput={this.props.chatInput}
                      chatInputDisplayValue={this.props.chatInputDisplayValue}
                      handleInput={this.props.handleInput}
                      handleFocus={this.props.handleFocus}
                      handleKeyUp={this.props.handleKeyUp}
                      handleKeyDown={this.props.handleKeyDown}
                      handleSubmit={this.props.handleSubmit}
                      isSpeech={this.props.isSpeech}
                      predSearchToggle={this.props.predSearchToggle}
                      predSearchResponse={this.props.predSearchResponse}
                      togglePredSearch={this.props.togglePredSearch}
                      assignPredSearchQues={this.props.assignPredSearchQues}
                      isInputDisabled={this.props.isInputDisabled}
                      numbersOnly={this.props.numbersOnly}
                      isPushBotVisible={this.props.isPushBotVisible}
                  />
      
            
            {
              this.props.isChatBodyVisible?
                <Footer data={this.props.data}
                isOverlayVisible={this.state.isOverlayFeedbackVisible}
                showOverlayFeedback={this.toggleOverlayFeedback.bind(this)}
                selectedRating={this.state.selectedRating}
                closeFlag={false}
                isFeedbackEnable={this.props.isFeedbackEnable}
              /> 
              : null
              } 
            </div>
            );
        }
    }

export default ChatBody;
